export default {
  getStudentsResult: (state) => state.studentsResult?.data,
  getStudentsResultPagination: (state) => state.studentsResult?.pagination,
};